import classNames from 'classnames';

export interface InputMetadataProps {
  value?: string;
  state: 'normal' | 'error';
  maxLength?: number;
}

export const InputMetadata = ({
  value,
  state,
  maxLength,
}: InputMetadataProps) => {
  return !!maxLength && value?.length >= 0.9 * maxLength ? (
    <span
      className={classNames(
        'grid grid-cols-2 font-ds-inter text-ds-200 font-ds-light tracking-ds-tight leading-ds-200',
        {
          normal: 'text-ds-natural-300',
          error: 'text-ds-danger-400',
        }[state]
      )}
      style={{
        gridTemplateAreas: `
      'bottomLabel charsCounter'
     `,
      }}
    >
      {!!maxLength && value?.length > maxLength && (
        <span style={{ gridArea: 'bottomLabel' }}>
          Search value is too long
        </span>
      )}
      {!!maxLength && value?.length >= 0.9 * maxLength && (
        <span
          className="justify-self-end"
          style={{ gridArea: 'charsCounter' }}
        >
          {`${value?.length}/${maxLength}`}
        </span>
      )}
    </span>
  ) : null;
};
